/**
 * Trigger mouse event for selected element
 *
 * @param {string} targetSelector - any valid selector, referring to the existed element.
 * @param {string} eventName - possible mouse event name
 */

export const triggerMouseEvent = (targetSelector, eventName) => {
    const targetElement = document.querySelector(targetSelector);

    if (targetElement) {
        const mouseEvent = new MouseEvent(eventName, {'bubbles': true});

        targetElement.dispatchEvent(mouseEvent);
    } else {
        throw new Error("Target element was not found");
    }
};